import React from 'react';
import { Section, Tag } from '../../components';
import { contacts, skills } from './config';
import './About.scss';
import pfp from '../../assets/about.png';

const About = () => {
    return (
        <Section
            title='about'
        >
            <div>
                <div className='about_display_container'>
                    <div className='about_display_content'>
                        <img src={pfp} className='about_display_content_img' alt='about pfp' />
                        <div className='about_display_content_links'>
                            {
                                contacts.map((item, index) =>
                                    <div className='about_display_content_links_name'>
                                        <div
                                            key={index}
                                            className='about_diamond'
                                        />
                                        <a target='_blank' rel='noopener noreferrer' href={item.url} className='about_display_content_links_name' style={{ textDecoration: 'none' }}>
                                            {item.name}
                                        </a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className='about_display_description'>
                    <div className='about_display_description_container'>
                        <div className='about_display_description_content'>
                            Hi! I'm Mindy!
                            I’ve always had a deep passion for art and visual storytelling, which naturally led me to this intersection of UI/UX design and frontend development.
                            With a degree in Computer Science and hands-on experience across the end-to-end design process, I focus on building equally beautiful and user-friendly web experiences.
                            <br></br><br></br>
                            Currently working as a UI/UX Frontend Developer, with focuses on:
                            <div className='about_display_description_content_tags'>
                                {skills?.map((skill, index) =>
                                    <Tag
                                        id={index}
                                        appearance='two-tone'
                                        type='tertiary'
                                    >
                                        {skill}
                                    </Tag>
                                )}
                            </div>
                            I’m constantly exploring new web technologies and design methodologies.
                            Take a look around my work, and feel free to get in touch if you'd like to collaborate!
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default About;